module.exports = __webpack_public_path__ + "img/activities-proof.fc20330b.png";